import { injectGlobal } from 'styled-components';

injectGlobal`
/* source-sans-pro-regular - latin */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  src: local('Source Sans Pro Regular'), local('SourceSansPro-Regular'),
       url('https://assets.homeimprovementpages.com.au/fonts/source-sans-pro-v10-latin-regular.5feb23.woff2') format('woff2'), /* Super Modern Browsers */
       url('https://assets.homeimprovementpages.com.au/fonts/source-sans-pro-v10-latin-regular.19ca4d.woff') format('woff'); /* Modern Browsers */
}

/* source-sans-pro-italic - latin */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: italic;
  font-weight: 400;
  src: local('Source Sans Pro Italic'), local('SourceSansPro-Italic'),
       url('https://assets.homeimprovementpages.com.au/fonts/source-sans-pro-v10-latin-italic.5a8dc9.woff2') format('woff2'), /* Super Modern Browsers */
       url('https://assets.homeimprovementpages.com.au/fonts/source-sans-pro-v10-latin-italic.8c0219.woff') format('woff'); /* Modern Browsers */
}

/* source-sans-pro-600 - latin */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  src: local('Source Sans Pro SemiBold'), local('SourceSansPro-SemiBold'),
       url('https://assets.homeimprovementpages.com.au/fonts/source-sans-pro-v10-latin-600.adc055.woff2') format('woff2'), /* Super Modern Browsers */
       url('https://assets.homeimprovementpages.com.au/fonts/source-sans-pro-v10-latin-600.a7c7b7.woff') format('woff'); /* Modern Browsers */
}

/* source-sans-pro-700 - latin */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 700;
  src: local('Source Sans Pro Bold'), local('SourceSansPro-Bold'),
       url('https://assets.homeimprovementpages.com.au/fonts/source-sans-pro-v10-latin-700.55823e.woff2') format('woff2'), /* Super Modern Browsers */
       url('https://assets.homeimprovementpages.com.au/fonts/source-sans-pro-v10-latin-700.be4ba3.woff') format('woff'); /* Modern Browsers */
}


/* yrsa-regular - latin */
@font-face {
  font-family: 'Yrsa';
  font-style: normal;
  font-weight: 400;
  src: local('Yrsa Regular'), local('Yrsa-Regular'),
       url('https://assets.homeimprovementpages.com.au/fonts/yrsa-v2-latin-regular.ab20c1.woff2') format('woff2'), /* Super Modern Browsers */
       url('https://assets.homeimprovementpages.com.au/fonts/yrsa-v2-latin-regular.20e5b8.woff') format('woff'); /* Modern Browsers */
}

/* roboto-v18-latin-regular */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  src: local('Roboto'), local('Roboto-Regular'),
       url('https://assets.homeimprovementpages.com.au/fonts/roboto-v18-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('https://assets.homeimprovementpages.com.au/fonts/roboto-v18-latin-regular.woff') format('woff'); /* Modern Browsers */
}

/* roboto-v18-latin-300 */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 300;
  src: local('Roboto Light'), local('Roboto-Light'),
       url('https://assets.homeimprovementpages.com.au/fonts/roboto-v18-latin-300.woff2') format('woff2'), /* Super Modern Browsers */
       url('https://assets.homeimprovementpages.com.au/fonts/roboto-v18-latin-300.woff') format('woff'); /* Modern Browsers */
}

/* roboto-v18-latin-700 */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  src: local('Roboto Bold'), local('Roboto-Bold'),
       url('https://assets.homeimprovementpages.com.au/fonts/roboto-v18-latin-700.woff2') format('woff2'), /* Super Modern Browsers */
       url('https://assets.homeimprovementpages.com.au/fonts/roboto-v18-latin-700.woff') format('woff'); /* Modern Browsers */
}
`;
